/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import React from 'react';
import {useNavigate} from 'react-router';
import {debug} from '../util/miscUtil';

export default function AppNavigator() {
    const navigate = useNavigate();

    function onNavigate(evt: React.MouseEvent) {
        const navigator: HTMLButtonElement = evt.target as HTMLButtonElement;
        const search = window.location.search;
        const url = navigator.dataset.url + (navigator.dataset.strip === '0' ? search : '');
        navigator.dataset.strip = '0';
        debug(`Navigating to ${url}`);
        navigate(url);
    }

    return (
        <button id='appNavigator' style={{display: 'none'}} data-url='' data-strip='0' onClick={onNavigate}/>
    )
}

// class AppNavigator extends React.Component<RouteComponentProps> {
//     static setNavigationData = (data: any) => {
//         navigationData = data;
//     };
//
//     static getNavigationData = (): any => navigationData;
//
//     navigate = (evt: any) => {
//         const {location, history} = this.props;
//         const navigator = evt.target,
//             url = navigator.dataset.url + (navigator.dataset.strip === '0' ? location.search : '');
//         navigator.dataset.strip = '0';
//         debug(`Navigating to ${url}`);
//         history.push(url);
//     };
//
//     render = () => {
//         return <button id='appNavigator' style={{display: 'none'}} data-url='' data-strip='0' onClick={this.navigate}/>
//     }
// }
//
// export default withRouter(AppNavigator);